export default __webpack_public_path__ + "./image/7ded8369780b80d40695f9f377c3da15.png";